import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function WhySection() {
  const benefits = ['Authorized sourcing from verified manufacturers', 'Regional warehousing in UAE for faster delivery', 'Fast B2B fulfillment with competitive lead times', 'Comprehensive RMA & warranty support', 'Compliance-ready documentation (MSDS/UN38.3 where applicable)', 'Dedicated account management for enterprise clients'];
  return <section id="why-us" className="py-20 px-6 relative overflow-hidden" data-id="element-278">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-279" />
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#F6F8FB] to-white" data-id="element-280" />
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-281">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-282">
          <h2 className="text-4xl font-bold text-[#0B1220] mb-4" data-id="element-283">
            Why Work With Us
          </h2>
          <p className="text-lg text-gray-600" data-id="element-284">
            Enterprise-grade distribution built for security-focused businesses
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white/90 backdrop-blur-sm rounded-2xl p-10 shadow-sm border border-gray-100" data-id="element-285">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-286">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-287">
                <CheckCircle2Icon className="w-6 h-6 text-[#10B981] flex-shrink-0 mt-1" data-id="element-288" />
                <p className="text-gray-700 leading-relaxed" data-id="element-289">{benefit}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}